import { useTranslation } from "react-i18next";

/** En-tête de la grille financière. */
export const FinanceGridHeader = () => {
    const [t] = useTranslation();

    return (
        <thead>
            <tr className="border-b border-border-color bg-backgroundZ1">
                <th className="py-2 px-3 text-xs font-semibold text-foreground">{t("PriceHistory.Channel")}</th>
                <th className="py-2 px-3 text-xs font-semibold text-foreground text-right">
                    {t("PriceHistory.Price")}
                </th>
                <th className="py-2 px-3 text-xs font-semibold text-foreground">{t("PriceHistory.Currency")}</th>
                <th className="py-2 px-3 text-xs font-semibold text-foreground">{t("PriceHistory.Period")}</th>
                <th className="py-2 px-3 text-xs font-semibold text-foreground">{t("PriceHistory.ChildCurrencies")}</th>
                <th />
            </tr>
        </thead>
    );
};
